import { Box } from "@mui/material";
import React from "react";
import { GridColDef, GridDataSource, GridDataSourceCache, GridDataSourceCacheDefault, GridGetRowsParams, GridGetRowsResponse, GridRenderCellParams, GridRowModesModel, useGridApiRef } from "@mui/x-data-grid";
import { formatNumber } from '../../Common/FormatNumber';
import CustomDataGrid from "../../Common/CustomDataGrid";

export default function Accounts({ theme, height, fullFeatured, pageSize }: { theme: string, height: number, fullFeatured: boolean, pageSize: number }){
    const [value, setValue] = React.useState('C');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const apiRef = useGridApiRef();
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const getColumns = (value: string): GridColDef[] => {
        return [
            {
                field: 'id',
                headerName: 'Cust ID',
                // headerName: value === 'C' ? 'Cust ID' : value === 'P' ? 'Prod ID' : 'Market ID',
                renderHeader: (params) => {
                    return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
                },
                flex: 0.5,
                align: 'center',
                headerAlign: 'center',
                type: 'string',
                renderCell: (params: GridRenderCellParams) => {
                    return <span>{params.value}</span>;
                },
            },
            {
                field: 'Item_nm',
                headerName: value === 'C' ? 'Customer' : value === 'R' ? 'Sales Rep' : value === 'L' ? 'Location' : value === 'P' ? 'Product' : 'Market',
                renderHeader: (params) => {
                    return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
                },
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                type: 'string',
                renderCell: (params: GridRenderCellParams) => {
                    return <span style={{ color: 'blue' }}>{params.value}</span>;
                },
            },
            {
                field: 'Mth12Sls',
                headerName: 'Current 12 Month Sales',
                renderHeader: (params) => {
                    return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Current 12 Month <br/> Sales</span>;
                },
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                type: 'number',
                filterable: false,
                renderCell: (params: GridRenderCellParams) => {
                    return <span>{formatNumber(params.value)}</span>;
                },
            },
            {
                field: 'Mth13_24Sls',
                headerName: 'Previous 12 Month Sales',
                renderHeader: (params) => {
                    return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Previous 12 Month <br/> Sales</span>;
                },
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                type: 'number',
                filterable: false,
                renderCell: (params: GridRenderCellParams) => {
                    return <span>{formatNumber(params.value)}</span>;
                },
            },
            {
                field: 'difference',
                headerName: 'Difference',
                renderHeader: (params) => {
                    return <span style={{ fontWeight: 'bold' }}>{params.colDef.headerName as string}</span>;
                },
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                type: 'number',
                filterable: false,
                renderCell: (params: GridRenderCellParams) => {
                    return <span style={{ color: params.value > 0 ? 'darkgreen' : 'red' }}>{formatNumber(params.value)}</span>;
                },
            },
            {
                field: 'TotWhisp',
                headerName: 'Whispers Found',
                renderHeader: (params) => {
                    return <span style={{ textAlign: 'center', fontWeight: 'bold' }}>Whispers <br/> Found</span>;
                },
                flex: 1,
                align: 'center',
                headerAlign: 'center',
                type: 'number',
                filterable: false,
            }
        ];
    }
    const columns = getColumns(value);

       
    const gridDataSource: GridDataSource = {
        getRows: async (params: GridGetRowsParams): Promise<GridGetRowsResponse> => {
            let urlDict = {};
      
            //   if (params.paginationModel.page > 0) {
            urlDict = {paginationModel: JSON.stringify(params.paginationModel)};
            //   }
            if (params.filterModel.items.length > 0) {
                // urlDict = {filterModel: JSON.stringify(params.filterModel)};
                urlDict = { ...urlDict, filterModel: JSON.stringify(params.filterModel) };
            }
            if (params.sortModel.length > 0) {
                // urlDict = {sortModel: JSON.stringify(params.sortModel)};
                urlDict = { ...urlDict, sortModel: JSON.stringify(params.sortModel) };
            }

          const urlParams = new URLSearchParams(urlDict);
          const baseParamsString = urlParams.size > 0 ? `?${urlParams.toString()}&entity_id=${localStorage.getItem('entity_id')}` : `?entity_id=${localStorage.getItem('entity_id')}`;
          const urlParamsString = baseParamsString;
          const response = await fetch(`/dashboard/my-accounts/${value}/${urlParamsString}`, {
            method: 'GET',
          });
          const data = await response.json();
          return {
            rows: data.rows,
            rowCount: data.rowCount,
          };
        },
    }

    const [lowTTLCache, setLowTTLCache] = React.useState<GridDataSourceCache>(() => new GridDataSourceCacheDefault({ ttl: 1000 * 10 }));

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', borderRadius: '6px !important', backgroundColor: 'white', border: '1px solid #f0f0f0 !important'}}>  
            <Box sx={{ width: '100%', typography: 'body1', height: '100%', margin: 0, padding: 0, borderRadius: '6px !important', backgroundColor: 'white' }}>
                {/* <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: 0 }}>
                        <Tabs 
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                            selectionFollowsFocus
                            onChange={handleChange} 
                            aria-label="lab API tabs example" 
                            value={value}
                            centered
                        >
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Customers" value="C" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Sales Reps" value="R" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Locations" value="L" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Products" value="P" />
                            <Tab wrapped style={{ textTransform: 'capitalize' }} label="Markets" value="M" />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} sx={{ margin: 0, padding: 0 }}> */}
                        <CustomDataGrid
                            message="No accounts found."
                            mode={theme}
                            columns={columns}
                            gridDataSource={gridDataSource}
                            sortModel={[]}
                            apiRef={apiRef}
                            rowModesModel={rowModesModel}
                            lowTTLCache={lowTTLCache}
                            navigate={false}
                            defineMaxHeight={height}
                            title={fullFeatured ? "My Accounts" : "My Accounts"}
                            tab={value}
                            fullFeatured={fullFeatured}
                            url={`/dashboard/my-accounts/${value}/`}
                            exportUrl={`/accounts/export/${value}/`}
                            pageSize={pageSize}
                        />
                    {/* </TabPanel> */}
                {/* </TabContext> */}
            </Box>
        </Box>
    )
}